import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  handleSetFilter,
  METRICS_FILTERS_KEY,
  shouldShowAllMetrics,
} from './helpers';
import { MetricsFilter } from './types';

export default function useMetricsFilters() {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();

  const currentFilters = useMemo(
    () => urlSearchParams.getAll(METRICS_FILTERS_KEY) as MetricsFilter[],
    [urlSearchParams],
  );

  const shouldShowAll = useMemo(
    () => shouldShowAllMetrics(currentFilters),
    [currentFilters],
  );

  const setFilter = useCallback(
    (filter: MetricsFilter) =>
      handleSetFilter(filter, urlSearchParams, setUrlSearchParams),
    [urlSearchParams, setUrlSearchParams],
  );

  return { currentFilters, setFilter, shouldShowAll };
}
